import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../styles/Navbar.css';

/**
 * Minimal, enterprise-style header for PowerBI dashboard
 * @param {Object} props
 * @param {string} props.user - User display name
 * @param {string} props.role - User role/location
 * @param {string} props.avatarUrl - Profile image URL
 * @param {string} props.initials - User initials for fallback avatar
 * @param {Function} props.onLogout - Logout handler
 * @returns {JSX.Element}
 */
const Navbar = ({ user, role, avatarUrl, initials, onLogout }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  // Fallback for missing initials
  const fallbackInitials = !initials && user ? (() => {
    const names = user.split(' ');
    if (names.length > 1) {
      return names[0].charAt(0) + names[1].charAt(0);
    }
    return names[0].charAt(0);
  })() : initials;

  return (
    <header className="navbar minimal-navbar">
      <div className="navbar-left">
        <span className="navbar-title">CP Finance Dashboard</span>
      </div>
      <div className="navbar-right">
        <div
          className="profile-container"
          tabIndex={0}
          onClick={() => setShowDropdown((v) => !v)}
          onBlur={() => setShowDropdown(false)}
        >          <div className="profile-info">
            <span className="profile-name">{user || ''}</span>
            {role && <span className="profile-role">{role}</span>}
          </div>{avatarUrl ? (
            <img src={avatarUrl} alt="avatar" className="profile-avatar" />
          ) : (
            <span className="profile-avatar fallback-avatar">{fallbackInitials}</span>
          )}
          {showDropdown && (
            <div className="profile-dropdown">
              <div className="dropdown-section dropdown-link">Profile Settings</div>
              <div className="dropdown-divider" />
              <div className="dropdown-section dropdown-link" onClick={onLogout}>Logout</div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

Navbar.propTypes = {
  user: PropTypes.string,
  role: PropTypes.string,
  avatarUrl: PropTypes.string,
  initials: PropTypes.string,
  onLogout: PropTypes.func.isRequired
};

export default React.memo(Navbar);
